import { Grid } from '@mui/material';

import { AnnualChart } from './AnnualChart';
import { Overview } from './Overview';
export const MetricsPage = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <AnnualChart />
      </Grid>
      <Grid sx={{ mt: 4 }} item xs={12}>
        <Overview />
      </Grid>
    </Grid>
  );
};
